exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mv-22[data-v-7d9af05a] {\n  margin: 22px 0;\n}\n.v-middle[data-v-7d9af05a] {\n  vertical-align: middle !important;\n}\n.pendente[data-v-7d9af05a] {\n  background-color: #FF8533;\n  color: #fff;\n}\n.recusada[data-v-7d9af05a] {\n  background-color: #dc3545;\n  color: #fff;\n}\n.aceita[data-v-7d9af05a] {\n  background-color: #01fe03;\n  color: #000;\n}\n.row[data-v-7d9af05a] {\n  margin: 0;\n}", ""]);

// exports
